import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import CancelIcon from '@mui/icons-material/Cancel';
import Chip from '@mui/material/Chip';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectChip(
  {
    handleInput, 
    placeholder = "Placeholder", 
    setValue = [],
    values = ["Option 1", "Option 2", "Option 3"]
  }
  ) {
  const theme = useTheme();
  const [selectInput, setselectInput] = useState(setValue);

  //Reset selected values when values change in the other input
  useEffect(() => {
    setselectInput(setValue)
  }, [setValue.length])

  //Send input value to parent component
  //useEffect to prevent infinite loop
  useEffect(() => {
    handleInput(selectInput)
  }, [selectInput])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setselectInput(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  function getStyles(name, selectInput, theme) {
    return {
      fontWeight:
        selectInput.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }
  
  const handleDelete = (e, value) => {
    e.preventDefault();
    setselectInput(selectInput.filter((name) => name !== value));
    };

  return (
    <div>
      <FormControl sx={{ m: 0, width: "100%" }}>
        <InputLabel id="demo-multiple-chip-label" className="text-th-white-900">{placeholder}</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={selectInput}
          onChange={(event) => {handleChange(event)}}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap'}}>
              {selected.map((value) => (
                <Chip 
                className='mx-0.5 my-0.5'
                key={value} 
                label={value}
                clickable
                deleteIcon={
                  <CancelIcon
                  onMouseDown={(e) => {e.stopPropagation();  e.preventDefault();}} />
                }
                 onDelete={(e) => handleDelete(e, value)}
                />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {values.map((name) => (
            <MenuItem
              key={name}
              value={name}
              style={getStyles(name, selectInput, theme)}
            >
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
